<template>
  <div>
    <v-row>
      <v-flex xs12 sm7 md6 lg9 xl8 class="pe-4 pe-sm-9 pe-md-15 pe-lg-9">
        <v-select :items="reportFilters" label="Report Type" v-model="reportFilter" item-text="text" item-value="value" dense filled solo attach></v-select>
      </v-flex>
      <v-flex xs12 sm4 md3 lg3 class="ms-6 ms-sm-1 ms-md-n8 ms-lg-n4 mb-4 mb-sm-0">
        <v-btn :disabled="!hasData" v-if="reportFilter" @click="startDeliveryExport">DOWNLOAD</v-btn>
        <v-snackbar v-model="exportStarted" timeout="6000" right top color="success"
          >Export Started
          <router-link class="dark--text" :to="{ name: 'ReportStatus' }">click here to view report status</router-link>
        </v-snackbar>
      </v-flex>
    </v-row>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
export default Vue.extend({
  props: {
    deliveryStatus: { require: true },
    deliveryShift: { require: true },
    reportId: { require: true },
    hasData: { require: true },
  },
  created() {},
  watch: {
    deliveryDate: {
      handler() {
        this.isInitLoaded = false;
        this.reportFilter = "";
      },
    },
    deliveryStatus: {
      handler() {
        this.isInitLoaded = false;
        this.reportFilter = "";
      },
    },
    deliveryShift: {
      handler() {
        this.isInitLoaded = false;
        this.reportFilter = "";
      },
    },
  },
  data() {
    return {
      loading: false,
      btnloading: false,
      reportFilter: "",
      exportStarted: false,
      isInitLoaded: false,
      pendingList: [],
      deliveryWithoutDislike: [],
      deliveryWithDislike: [],
      reportFilters: [
        { text: "Delivey Sticker", value: "SET_MENU_DELIVERY" },
        {
          text: "Export",
          value: "SET_MENU_EXPORT",
        },
      ],
    };
  },

  methods: {
    startDeliveryExport() {
      const dateTime = moment(`${this.deliveryDate}`).format("YYYY-MM-DD");
      let modifiedDate = new Date(dateTime);
      this.$apollo
        .watchQuery({
          query: require("@/delivery/api/excelDeliveryExportReport.graphql"),
          variables: {
            status: this.deliveryStatus,
            date: modifiedDate,
            type: this.reportFilter,
            shift: this.deliveryShift,
            reportId: this.reportId,
          },
        })
        .refetch({
          variables: {
            status: this.deliveryStatus,
            date: modifiedDate,
            type: this.reportFilter,
            shift: this.deliveryShift,
            reportId: this.reportId,
          },
        })
        .then(() => {})
        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
        });
      this.exportStarted = true;
    },
  },
});
</script>
